import { render, staticRenderFns } from "./ProjectSetup.vue?vue&type=template&id=42b8c4a2&"
import script from "./ProjectSetup.vue?vue&type=script&lang=js&"
export * from "./ProjectSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports